import { Heading} from "grommet";

const SubHeader = (props) => {
  return (
    <Heading level={3} margin={"small"} size="small">
      <u>{props.children}</u>
    </Heading>
  );
};

export default SubHeader;
